<template>
  <div class="tw:p-4">
    <div class="tw:mb-4 tw:font-bold">
      {{ getLocaleText("stream_filters_content_types.heading") }}
    </div>

    <div class="tw:flex tw:gap-4">
      <Checkbox
        v-if="showNLAOption"
        v-model="localLicense"
        data-testid="option-nla"
        dense
        :label="getLocaleText('stream_filters_content_types.license.nla')"
        new-design
        value="nla"
      />
      <Checkbox
        v-if="showCLAOption"
        v-model="localLicense"
        data-testid="option-cla"
        dense
        :label="getLocaleText('stream_filters_content_types.license.cla')"
        new-design
        value="cla"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import Checkbox from "shared/components/core/forms/Checkbox.vue";
import type { StreamFiltersLicense } from "shared/helpers/StreamFilters";
import useUserStore from "shared/stores/user";

const liceneseOptions: StreamFiltersLicense[] = ["nla", "cla"];

const userStore = useUserStore();

const { organisation } = storeToRefs(userStore);

const showNLAOption = computed<boolean>(() =>
  organisation.value.features.some((feature) => feature.includes("nla"))
);

const showCLAOption = computed<boolean>(() =>
  organisation.value.features.some((feature) => feature.includes("cla"))
);

const excludedLicense = defineModel<StreamFiltersLicense[]>("excludedLicense", {
  default: () => [],
});

const localLicense = computed<StreamFiltersLicense[]>({
  get() {
    return liceneseOptions.filter(
      (licenseOption) => !excludedLicense.value.includes(licenseOption)
    );
  },
  set(value) {
    excludedLicense.value = liceneseOptions.filter(
      (licenseOption) => !value.includes(licenseOption)
    );
  },
});
</script>
